import { Component, OnInit } from '@angular/core';
import { SportIcon } from 'src/app/models/enums';

@Component({
  selector: 'app-svg-definitions',
  templateUrl: './svg-definitions.component.html',
  styleUrls: ['./svg-definitions.component.less']
})
export class SvgDefinitionsComponent implements OnInit {
  sportIconEnum = SportIcon;

  constructor() { }

  ngOnInit(): void {
  }

}
